import type { Reference } from '@platform/entities/entity.class';
import { ConnectDao, Entity } from '@platform/entities/entity.class';
import { Column, Table } from '@platform/shared/rpc/entity-decorators';
import { DataType } from '@platform/shared/rpc/types';
import { EmployeeProjectDao } from '@platform/entities/employee_project/employee_project.dao';

@ConnectDao(EmployeeProjectDao)
@Table({ tableName: 'employee_project', schemaName: 'pusk', comment: 'employee_project' })
export class EmployeeProjectEntity extends Entity {
    @Column(DataType.UUID, { ref: 'pusk.employee', comment: 'Сотрудник' })
    employee_id?: Reference;

    @Column(DataType.UUID, { ref: 'platform.project', comment: 'Проект' })
    project_id?: Reference;
}
